<script>
</script>

<div class="divider"></div>

<div id="about_work" class="section">
  <div class="container">
    <div class="row">
      <h3 class="blue-grey-text text-lighten-2">About my work</h3>

      <p class="flow-text">
        My work is inspired by <em>Futurism</em> and late <em>Cubism</em>,
        movements that celebrated progress, and the dynamic complexity of modern
        life. I call my style <strong><em>"Reformist Neo-Cubism"</em></strong>,
        a personal interpretation that fuses these influences by combining
        structural analysis with dynamic exploration. The compositions explore
        how figures interact with their surroundings, revealing layers of
        complexity through bold colors and fragmented, overlapping forms. The
        optimistic view of technological progress in early Futurism aligns with
        how I see the world and has ultimately fueled my interest and passion
        for software development and data science.
      </p>
      <p class="flow-text">
        Over the years, my work has been acquired by numerous art collectors and
        exhibited in galleries across Guadalajara (Mexico), San Francisco, Las
        Vegas and Dallas (USA), Denmark, Faroe Islands, Italy and South America.
      </p>

      <p class="flow-text">
        A few years ago, my work was nominated for inclusion in the permanent
        collections of the following museums. Although it was not ultimately
        selected, being reviewed by their acquisition committees was a
        significant honor and recognition of my work.
      </p>
      <ul class="list">
        <li class="collection-item">
          <strong>NMMA</strong>, National Museum of Mexican Art. Chicago IL.
        </li>
        <li class="collection-item">
          <strong>MOLAA</strong>, Museum of Latin American Art. Long Beach CA.
        </li>
        <li class="collection-item">
          <strong>MALBA</strong>, Museo de Arte Latinoamericano de Buenos Aires.
          Buenos Aires, Argentina.
        </li>
      </ul>
    </div>
  </div>
</div>

<style>
  .list {
    margin-left: 25px;
  }
  .list li {
    list-style-type: square !important;
  }

  @media screen and (min-width: 400px) {
    .flow-text {
      font-size: 1.2em;
    }
  }
</style>
